/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_Trained_ForInputs */

const en_us2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long you trained`)
};

const pt_br2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo que treinou`)
};

const es_419_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuánto tiempo entrenaste`)
};

const pt_pt2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo que treinaste`)
};

const fr_fr2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps tu t'es entraîné`)
};

const de_de2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange du trainiert hast`)
};

const it_it2_profile_row_trained_for = /** @type {(inputs: Profile_Row_Trained_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per quanto ti sei allenato`)
};

/**
* | output |
* | --- |
* | "How long you trained" |
*
* @param {Profile_Row_Trained_ForInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_trained_for = /** @type {((inputs?: Profile_Row_Trained_ForInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_Trained_ForInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_trained_for(inputs)
	if (locale === "es-419") return es_419_profile_row_trained_for(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_trained_for(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_trained_for(inputs)
	if (locale === "de-DE") return de_de2_profile_row_trained_for(inputs)
	if (locale === "it-IT") return it_it2_profile_row_trained_for(inputs)
	return en_us2_profile_row_trained_for(inputs)
});
export { profile_row_trained_for as "profile.row_trained_for" }